// prefer default export if available
var preferDefault = function preferDefault(m) {
  return m && m.default || m;
};

exports.components = {
  "component---web-pages-404-tsx": function componentWebPages404Tsx() {
    return import("/Users/rodrigo/Trabajo/Chatito/web/pages/404.tsx"
    /* webpackChunkName: "component---web-pages-404-tsx" */
    );
  },
  "component---web-pages-index-tsx": function componentWebPagesIndexTsx() {
    return import("/Users/rodrigo/Trabajo/Chatito/web/pages/index.tsx"
    /* webpackChunkName: "component---web-pages-index-tsx" */
    );
  }
};